import api from '../_api';

const actions = {
    hpcenrollRequest: ({commit, dispatch}) => {

        return new Promise((resolve, reject) => {
            commit('ENROLL_LOADING');

            api.enrollments()
                .then((resp) => {
                    commit('ENROLL_SUCCESS', resp.data.data);
                    resolve(resp.data);
                })
                .catch((err) => {
                    let errors = err.response.data.errors ? err.response.data.errors.error : err.response.data.error;

                    commit('ENROLL_ERROR', errors);
                    reject(err.response);
                });
        })
    },
    clearHpcenrollErrors:({commit}) => {
        commit('CLEAR_ENROLL_ERRORS');
    },
}

export default actions
